module.exports = __webpack_public_path__ + "static/media/search.8535ab3f.svg";